<script>
  import PureButton from "../../utils/PureButton.svelte";
  import StatusTag from "./StatusTag.svelte";

  let {
    children,
    onclick,
    disabled,
    active,
    size,
    kind = "information",
  } = $props();

  const brMap = {
    small: "8px",
    medium: "8px",
    large: "8px",
  };

  let br = $derived(brMap[size] || "");
  let style = $derived(br ? `border-radius: ${br}` : "");
</script>

<PureButton {onclick} {disabled} {style}>
  <StatusTag {size} {active} {disabled} {kind} interactive>
    {@render children()}
  </StatusTag>
</PureButton>
